import React, { useState } from 'react';
import styled from 'styled-components';
import { 
  FaPlus,
  FaEdit,
  FaTrash,
  FaShieldAlt,
  FaUserShield,
  FaCog,
  FaUsers
} from 'react-icons/fa';

import './Permission.css';
import img1 from './img/img1.png';
import img2 from './img/img2.png';
import PermissionsModal from './PermissionsModal';
import AddDesignationForm from './AddDesignationForm';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  min-height: 100vh;

  @media (min-width: 768px) {
    padding: 2rem;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  flex-direction: column;
  gap: 1rem;
  
  @media (min-width: 768px) {
    flex-direction: row;
    gap: 0;
  }
`;

const Title = styled.h1`
  font-size: 1.75rem;
  font-weight: 700;
  color: #212529;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 1rem;
  text-align: center;
  
  svg {
    font-size: 1.5rem;
    color: #0d6efd;
  }
  
  @media (min-width: 768px) {
    font-size: 2.5rem;
    text-align: left;
    
    svg {
      font-size: 2rem;
    }
  }
`;

const AddButton = styled.button`
  background: linear-gradient(135deg, #0d6efd 0%, #4285f4 100%);
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  transition: all 0.3s ease;
  font-size: 1rem;
  width: 100%;
  justify-content: center;
  
  svg {
    font-size: 1.1rem;
  }
  
  &:hover {
    background: linear-gradient(135deg, #0a58ca 0%, #1a73e8 100%);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(13, 110, 253, 0.3);
  }

  @media (min-width: 768px) {
    width: auto;
  }
`;

const TableCard = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

const TableHeader = styled.div`
  background: linear-gradient(135deg, #0d6efd 0%, #4285f4 100%);
  color: white;
  padding: 1rem;
  
  @media (min-width: 768px) {
    padding: 1.5rem 2rem;
  }
`;

const TableTitle = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  
  svg {
    font-size: 1.1rem;
  }
  
  @media (min-width: 768px) {
    font-size: 1.5rem;
    
    svg {
      font-size: 1.3rem;
    }
  }
`;

const TableContainer = styled.div`
  padding: 0;
  background: white;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
  min-width: 600px;
  
  @media (min-width: 768px) {
    font-size: 0.95rem;
    min-width: auto;
  }
`;

const TableHead = styled.thead`
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
`;

const TableRow = styled.tr`
  transition: all 0.2s ease;
  
  &:hover {
    background: #f8f9fa;
  }
  
  &:not(:last-child) {
    border-bottom: 1px solid #dee2e6;
  }
`;

const TableHeaderCell = styled.th`
  padding: 0.75rem 1rem;
  text-align: left;
  font-weight: 600;
  color: #495057;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #dee2e6;
  
  &:first-child {
    width: 10%;
    text-align: center;
  }
  
  &:nth-child(2) {
    width: 50%;
  }
  
  &:last-child {
    width: 40%;
    text-align: center;
  }
  
  @media (min-width: 768px) {
    padding: 1rem 1.5rem;
    font-size: 0.875rem;
    
    &:first-child {
      width: 8%;
    }
    
    &:nth-child(2) {
      width: 60%;
    }
    
    &:last-child {
      width: 32%;
    }
  }
`;

const TableCell = styled.td`
  padding: 0.75rem 1rem;
  vertical-align: middle;
  
  &:first-child {
    text-align: center;
    font-weight: 600;
    color: #0d6efd;
  }
  
  &:last-child {
    text-align: center;
  }
  
  @media (min-width: 768px) {
    padding: 1rem 1.5rem;
  }
`;

const ActionGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  flex-direction: column;
  
  @media (min-width: 576px) {
    flex-direction: row;
    gap: 0.75rem;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.3s ease;
  
  &:hover {
    background: #f8f9fa;
    transform: scale(1.1);
  }
  
  &.edit:hover {
    background: rgba(13, 110, 253, 0.1);
  }
  
  &.delete:hover {
    background: rgba(220, 53, 69, 0.1);
  }
  
  img {
    width: 32px;
    height: 32px;
  }
  
  @media (min-width: 768px) {
    width: 36px;
    height: 36px;
    
    img {
      width: 40px;
      height: 40px;
    }
  }
`;

const PermissionButton = styled.button`
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  padding: 0.4rem 0.8rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.75rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  white-space: nowrap;
  
  svg {
    font-size: 0.8rem;
  }
  
  &:hover {
    background: linear-gradient(135deg, #218838 0%, #1ea97c 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
  }
  
  @media (min-width: 768px) {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    gap: 0.5rem;
    
    svg {
      font-size: 0.9rem;
    }
  }
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 2rem 1rem;
  color: #6c757d;
  
  @media (min-width: 768px) {
    padding: 3rem 2rem;
  }
`;

const EmptyIcon = styled.div`
  font-size: 3rem;
  color: #dee2e6;
  margin-bottom: 1rem;
  
  svg {
    font-size: 3rem;
  }
  
  @media (min-width: 768px) {
    font-size: 5rem;
    
    svg {
      font-size: 5rem;
    }
  }
`;

// Mobile Card Component for enhanced mobile experience
const MobileCard = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
  padding: 1rem;
  border: 1px solid #e9ecef;
  
  @media (min-width: 768px) {
    display: none;
  }
`;

const MobileCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

const MobileCardTitle = styled.h6`
  margin: 0;
  color: #212529;
  font-weight: 600;
  font-size: 1rem;
`;

const MobileCardId = styled.span`
  background: #f8f9fa;
  color: #0d6efd;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
`;

const MobileCardActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
`;

const MobileActionGroup = styled.div`
  display: flex;
  gap: 0.5rem;
`;

// EXACT ORIGINAL COMPONENT WITH PRESERVED LOGIC - NO FUNCTIONAL CHANGES
const Permission = () => {
  // EXACT ORIGINAL STATE - NO CHANGES
  const [permissions, setPermissions] = useState([
    { id: 1, name: 'Admin' },
    { id: 2, name: 'Super Admin' },
    { id: 3, name: 'Managing Director' },
    { id: 4, name: 'HR Department Head' },
    { id: 5, name: 'Manager - Finance' },
  ]);

  const [showModal, setShowModal] = useState(false);
  const [selectedPermission, setSelectedPermission] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [newPermissionName, setNewPermissionName] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);

  // Check if screen is mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // EXACT ORIGINAL FUNCTIONS - NO CHANGES
  const handlePermissionsClick = (permission) => {
    setSelectedPermission(permission);
    setShowModal(true);
  };

  const handleEditPermission = (permission) => {
    setSelectedPermission(permission);
    setNewPermissionName(permission.name);
    setIsEditing(true);
    setShowAddForm(true);
  };

  const handleSaveEdit = (updatedName) => {
    setPermissions(permissions.map(permission =>
      permission.id === selectedPermission.id
        ? { ...permission, name: updatedName }
        : permission
    ));
    setIsEditing(false);
    setSelectedPermission(null);
    setNewPermissionName('');
    setShowAddForm(false);
  };

  const handleDeletePermission = (permissionId) => {
    setPermissions(permissions.filter(permission => permission.id !== permissionId));
  };

  const handleAddDesignation = (designationName) => {
    if (isEditing) {
      handleSaveEdit(designationName);
    } else {
      const newPermission = {
        id: permissions.length + 1,
        name: designationName,
      };
      setPermissions([...permissions, newPermission]);
      setShowAddForm(false);
    }
  };

  const handleAddButtonClick = () => {
    setShowAddForm(true);
    setIsEditing(false);
    setNewPermissionName(''); // Reset input for new designation
  };

  return (
    <Container>
      <Header>
        <Title>
          <FaShieldAlt />
          Permissions & Roles
        </Title>
        <AddButton onClick={handleAddButtonClick}>
          <FaPlus />
          Add Designation
        </AddButton>
      </Header>

      <TableCard>
        <TableHeader>
          <TableTitle>
            <FaUserShield />
            Role Management
          </TableTitle>
        </TableHeader>

        {isMobile ? (
          // Mobile Card View
          <div style={{ padding: '1rem' }}>
            {permissions.length > 0 ? (
              permissions.map((permission) => (
                <MobileCard key={permission.id}>
                  <MobileCardHeader>
                    <MobileCardTitle>{permission.name}</MobileCardTitle>
                    <MobileCardId>#{permission.id}</MobileCardId>
                  </MobileCardHeader>
                  
                  <MobileCardActions>
                    <MobileActionGroup>
                      <IconWrapper 
                        className="edit"
                        onClick={() => handleEditPermission(permission)}
                      >
                        <img src={img1} alt="edit" />
                      </IconWrapper>
                      <IconWrapper 
                        className="delete"
                        onClick={() => handleDeletePermission(permission.id)}
                      >
                        <img src={img2} alt="delete" />
                      </IconWrapper>
                    </MobileActionGroup>
                    <PermissionButton
                      onClick={() => handlePermissionsClick(permission)}
                    >
                      <FaCog />
                      Permissions
                    </PermissionButton>
                  </MobileCardActions>
                </MobileCard>
              ))
            ) : (
              <EmptyState>
                <EmptyIcon>
                  <FaUsers />
                </EmptyIcon>
                <h3>No Permissions Found</h3>
                <p>Click "Add Designation" to create your first role.</p>
              </EmptyState>
            )}
          </div>
        ) : (
          // Desktop Table View
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableHeaderCell>#</TableHeaderCell>
                  <TableHeaderCell>Designation Name</TableHeaderCell>
                  <TableHeaderCell>Actions</TableHeaderCell>
                </TableRow>
              </TableHead>
              <tbody>
                {permissions.length > 0 ? (
                  permissions.map((permission) => (
                    <TableRow key={permission.id}>
                      <TableCell>{permission.id}</TableCell>
                      <TableCell>{permission.name}</TableCell>
                      <TableCell>
                        <ActionGroup>
                          <IconWrapper 
                            className="edit"
                            onClick={() => handleEditPermission(permission)}
                          >
                            <img src={img1} alt="edit" />
                          </IconWrapper>
                          <IconWrapper 
                            className="delete"
                            onClick={() => handleDeletePermission(permission.id)}
                          >
                            <img src={img2} alt="delete" />
                          </IconWrapper>
                          <PermissionButton
                            onClick={() => handlePermissionsClick(permission)}
                          >
                            <FaCog />
                            Permissions
                          </PermissionButton>
                        </ActionGroup>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan="3">
                      <EmptyState>
                        <EmptyIcon>
                          <FaUsers />
                        </EmptyIcon>
                        <h3>No Permissions Found</h3>
                        <p>Click "Add Designation" to create your first role.</p>
                      </EmptyState>
                    </TableCell>
                  </TableRow>
                )}
              </tbody>
            </Table>
          </TableContainer>
        )}
      </TableCard>

      {/* Preserving exact AddDesignationForm logic */}
      {showAddForm && (
        <AddDesignationForm
          onAddDesignation={handleAddDesignation}
          onClose={() => setShowAddForm(false)}
          editMode={isEditing}
          designationName={newPermissionName}
          setDesignationName={setNewPermissionName}
        />
      )}

      {/* Preserving exact PermissionsModal logic */}
      {showModal && (
        <PermissionsModal
          onClose={() => setShowModal(false)}
          designationName={selectedPermission.name}
        />
      )}
    </Container>
  );
};

export default Permission;